import { Dialog } from "@material-ui/core";
import React, { useState, Fragment, useEffect } from "react";
import "./EmissionsSummary.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { dateParser, parseDateMonth } from "../../../helper";
import { successMessage } from "../../../constants/messageConstants";
import { getSourceNameByCategory, getSourceValue } from "../EmissionConfig";
import ErrorSummary from "../ErrorSummary/ErrorSummary";
import { useSelector } from "react-redux";
import { setErrorsByFile } from "../../../services/emissionService";
import { STEPS } from "../../../constants/enums";
import { useTranslation } from "react-i18next";

const getEngineDetail = (eachLog: any) => {
  let { engine_name, fuel_name } = eachLog;
  const sep = engine_name && fuel_name ? "-" : "";
  engine_name = engine_name || "";
  fuel_name = fuel_name || "";
  return `${engine_name}${sep}${fuel_name}`;
};

function EmissionsSummary(props: any) {
  const { t, i18n } = useTranslation();
  const {
    open,
    setOpen,
    setStep,
    emissionData,
    selectedCategory,
    isBulkUpload,
    uploadedFiles,
    showErrorDialog,
    setShowErrorDialog,
    step,
  } = props;
  // const [viewEmissionFlag, setViewEmissionFlag] = useState(false);
  const navigate = useNavigate();
  // const [openErrorDialog, setOpenErrorDialog] = useState(true);
  const { state } = useLocation();
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });
  const [fileErrors, setFileErrors] = useState([]);
  const [fileDetails, setFileDetails] = useState(
    useSelector((state: any) => state.file.fileDetails)
  );

  useEffect(() => {
    if (fileDetails.errors && Object.keys(fileDetails.errors).length > 0) {
      setFileErrors(setErrorsByFile(fileDetails));
      // setOpenErrorDialog(true);
    }
  }, [fileDetails]);

  const addNewEmission = (emissionDetail: string) => {
    navigate("/log/Emissions", {
      state: {
        emissionDetail: emissionDetail,
        viewEmissionFlag: true,
        id: emissionData.emission[0].id,
        type: state.step,
      },
    });
  };
  const handleView = (type?: string) => {
    if (type === "detail") {
      addNewEmission(type);
    }
  };
  return (
    <Fragment>
      <div>
        <>
          {showErrorDialog ? (
            <Dialog open={open} fullWidth maxWidth="xl">
              <ErrorSummary
                setOpen={setShowErrorDialog}
                fileErrors={fileErrors}
                categoryID={selectedCategory.id}
                controller={controller}
              />
            </Dialog>
          ) : (
            <Dialog
              open={open}
              onClose={() => {
                setOpen(false);
                navigate("/Log/Emissions", {
                  state: {
                    type: state.step,
                  },
                });
              }}
              maxWidth="md"
              className="pw-emission-summary-dialog"
            >
              <div className="pw-emission-dialog-margin pw-emission-summary-header pw-border-400 pb-2 flex flex-col">
                <div className="pw-input-label flex justify-between pw-create-label ">
                  <p>{t("Emissions Summary")}</p>
                  <CloseIcon
                    className="cursor-pointer"
                    onClick={() => {
                      setOpen(false);
                      navigate("/Log/Emissions", {
                        state: {
                          type: state.step,
                        },
                      });
                    }}
                  />
                </div>
                {!isBulkUpload && (
                  <div className="flex flex-row gap-2 text-sm	 justify-between">
                    <div className="gap-1 flex">
                      <p className="text-neutral-600">
                        {t("Preferred Emission Factor")} :
                      </p>
                      <p className="text-neutral-900">
                        {emissionData?.emission[0]?.sub_type_name}
                      </p>
                      {/* ToBeModified */}
                    </div>
                    <div className="gap-1  flex">
                      <p className="text-neutral-600">
                        {t("Log Emission against")}:
                      </p>
                      <p className="text-neutral-900">
                        {emissionData?.emission[0]?.method_name || "-"}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="pw-emission-dialog-wrapper flex flex-col gap-5 ">
                <div className="pw-emission-dialog flex flex-col gap-5">
                  <div className="pw-bunit-create-desc ">
                    <p className="text-sm text-neutral-700 mt-4">
                      {successMessage().EMISSION_SUCCESS}
                    </p>
                  </div>
                  {isBulkUpload ? (
                    <div className="flex flex-col gap-2 items-center justify-center font-semibold pw-checkcircle-box">
                      <CheckCircleIcon className="pw-check-icon text-success py-5" />
                      <div className="text-sm pw-e2e-logsummarycontent">
                        {uploadedFiles.size -
                          Object.keys(uploadedFiles?.errors).length +
                          " of " +
                          uploadedFiles.size +
                          " "}{" "}
                        {t("records has been logged")}
                      </div>
                      {/* <div>
                        <Alert severity="warning" className="bg-white">
                          Download the file to view the records with errors
                          Sample.xls
                        </Alert>
                      </div> */}
                    </div>
                  ) : (
                    <div className="flex flex-col gap-2 items-center justify-center font-semibold pw-checkcircle-box">
                      <CheckCircleIcon className="pw-check-icon text-success" />
                      <div className="text-sm">
                        {t("Your emission has been logged")}
                      </div>
                    </div>
                  )}
                  <div className="flex flex-row pw-border-300 pb-4 justify-between">
                    {isBulkUpload ? (
                      // uploadedFiles.map((file: any) => {
                      //   return (
                      <div className="flex flex-row gap-1">
                        <p className="text-neutral-700 text-sm">
                          {uploadedFiles.category_code}
                        </p>
                        <p className="text-neutral-900 text-sm">
                          {uploadedFiles.category_name}
                        </p>
                      </div>
                    ) : (
                      //   );
                      // })
                      <div className="flex flex-row gap-1">
                        <p className="text-neutral-700 text-sm">
                          {selectedCategory.code}
                        </p>
                        <p className="text-neutral-900 text-sm">
                          {selectedCategory.name}
                        </p>
                      </div>
                    )}
                    {!isBulkUpload && (
                      <div className="flex flex-row text-neutral-600 text-sm text-right">
                        {t("Duration")}:&nbsp;
                        {parseDateMonth(emissionData.emission[0].from_date) ===
                        parseDateMonth(emissionData.emission[0].to_date)
                          ? parseDateMonth(emissionData.emission[0].from_date)
                          : parseDateMonth(emissionData.emission[0].from_date) +
                            " - " +
                            parseDateMonth(emissionData.emission[0].to_date)}
                      </div>
                    )}
                  </div>
                  {isBulkUpload ? (
                    // uploadedFiles.map((file: any) => {
                    //   return (
                    <div className="flex flex-row justify-between items-center">
                      <div className="flex flex-row gap-1 items-center">
                        <p className="text-sm text-neutral-600">
                          {t("Modified on")}:{" "}
                        </p>
                        <p
                          className="text-sm text-neutral-900"
                          id="pw-e2e-logassetmodifiedtime"
                        >
                          {/* {parseDate(emissionData.emission[0].from_date)} */}
                          {dateParser(uploadedFiles.created)}
                        </p>
                      </div>
                      <div className="flex flex-row gap-1 items-center">
                        <p className="text-sm text-neutral-600">
                          {t("Modified by")}:{" "}
                        </p>
                        <p
                          className="text-sm text-neutral-900"
                          id="pw-e2e-logassetmodifiedby"
                        >
                          {uploadedFiles.owner_name}
                        </p>
                      </div>
                    </div>
                  ) : (
                    //   );
                    // })
                    <div className="flex flex-row justify-between items-center">
                      <div className="flex flex-row gap-1 items-center">
                        <p className="text-sm text-neutral-600">
                          {t("Modified on")}:{" "}
                        </p>
                        <p className="text-sm text-neutral-900">
                          {dateParser(emissionData.emission[0].last_updated)}
                        </p>
                      </div>
                      <div className="flex flex-row gap-1 items-center">
                        <p className="text-sm text-neutral-600">
                          {t("Modified by")}:{" "}
                        </p>
                        <p className="text-sm text-neutral-900">
                          {emissionData.emission[0].last_updated_by_name}
                        </p>
                      </div>
                    </div>
                  )}
                  {!isBulkUpload && (
                    <div className="flex flex-col gap-6">
                      {emissionData.emissionLogs.length &&
                        emissionData.emissionLogs.map((eachLog: any) => {
                          return (
                            <div className="flex flex-col gap-6 pw-background-card p-4	">
                              <div className="flex flex-row pw-border-300 pb-3 justify-between">
                                <div className="flex flex-row gap-1">
                                  <p className="text-neutral-500 text-sm">
                                    {t("Emission ID")}:
                                  </p>
                                  <p className="text-neutral-900 text-sm font-semibold	">
                                    {eachLog.log_code}{" "}
                                  </p>
                                </div>
                                <div className="text-neutral-900 text-sm font-semibold text-right">
                                  <p className="pw-emission-value">
                                    {eachLog.total_value.toFixed(2)}{" "}
                                    {eachLog.final_uom_name}
                                  </p>
                                </div>
                              </div>
                              <div className="flex flex-row justify-between">
                                <div className="flex flex-row gap-2">
                                  <p className="text-neutral-900 text-sm">
                                    {state.step === STEPS.ASSETS ? (
                                      "Asset ID :"
                                    ) : (
                                      <div>
                                        {getSourceNameByCategory(
                                          emissionData.emission[0]
                                        )}{" "}
                                        :
                                      </div>
                                    )}
                                  </p>
                                  <div className="flex flex-col">
                                    <div className="pw-source-name text-neutral-900 text-sm ">
                                      {emissionData?.local_code?.length > 0 ? (
                                        <span>
                                          <span
                                            style={{ fontSize: "14px" }}
                                            className="pw-text-neutral-900 font-bold"
                                          >
                                            {emissionData.local_code}{" "}
                                          </span>
                                          <div className="pw-text-neutral-600 text-sm">
                                            {getSourceValue(
                                              emissionData.emission[0],
                                              eachLog
                                            )}
                                          </div>
                                        </span>
                                      ) : (
                                        <span>
                                          {getSourceValue(
                                            emissionData.emission[0],
                                            eachLog
                                          )}
                                        </span>
                                      )}
                                    </div>
                                    <div className="pw-engine-name text-neutral-600 text-xs">
                                      {getEngineDetail(eachLog)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
                <div className="flex flex-row justify-end pw-emission-summary-footer w-full gap-6">
                  {!isBulkUpload && (
                    <div
                      className="pw-emission-summary-clone"
                      onClick={() => handleView("detail")}
                    >
                      {t("View")}
                    </div>
                  )}
                  {isBulkUpload ? (
                    <div
                      className="pw-emission-summary-add"
                      onClick={() => setStep(STEPS.ACTIVITY_DATA)}
                    >
                      {t("Add Another")}
                    </div>
                  ) : (
                    <div
                      className="pw-emission-summary-add"
                      onClick={() => setStep(STEPS.SELECT_SCOPE)}
                    >
                      {t("Add Another")}
                    </div>
                  )}
                </div>
              </div>
            </Dialog>
          )}
        </>
      </div>
    </Fragment>
  );
}
export default EmissionsSummary;
